import React from 'react';
import { Chip } from '@mui/material';
import { Text, Theme, i18n, tokens } from '@simplybenefits/sb-ui-library';

import UsageBlock from './UsageBlock.js';

/**
 * @param usage
 * @param coverage
 * @returns {*}
 * @constructor
 */
const DrugsUsageBlock = ({ usage, coverage, fillColor, waivedEHC }) => (
    <React.Fragment>
        <div style={{ marginTop: 20 }}>
            <Text
                medium
                bold
                customStyle={{ 
                    flex: 1,
                    display: 'inline',
                    margin: '20px 0 10px 0'
                }}
            >
                { i18n.t(tokens.titles.drugs) }
            </Text>
            {
                waivedEHC &&
                    <Chip
                        size="small"
                        label="Waived"
                        color="primary"
                        variant="outlined"
                        style={{
                            margin: "5px 10px",
                            borderRadius: 30,
                            borderWidth: 2,
                            borderColor: Theme.colors.lightGrey,
                            fontFamily: Theme.fonts.type.heading,
                            fontSize: 14,
                            color: '#666'
                        }}
                    />
            }
        </div>

        {
            usage.used.map((item) => {
                let limit = coverage[item.coverageColumn] || 0;
                let limitText = false;
                let notDollar = false;

                if (item.type === 'Erectile Dysfunction Drugs' && coverage.includeErectDysfuncDrugs === 0) {
                    return null;
                }

                if (item.type === 'Fertility Drugs' && coverage.includeFertilityDrugs === 0) {
                    return null;
                }

                if (item.type === 'Preventative Vaccines' && coverage.includePreventativeVaccines === 0) {
                    return null;
                }

                if (item.type === 'Smoking Cessations' && coverage.includeSmokingCessations === 0) {
                    return null;
                }

                if (item.type === 'Preventative Vaccines' && coverage.preventativeVaccinesIsRC) {
                    limitText = i18n.t(tokens.labels.coverage.unlimited);
                    limit = 50000;
                }

                if (item.type.includes('Generic') && (!coverage.hasOverallMax || coverage.secondMax.toUpperCase() === 'UNLIMITED')) {
                    limitText = i18n.t(tokens.labels.coverage.unlimited);
                    limit = 50000;
                }

                if (coverage[item.coverageColumn] || limitText) {
                    return (
                        <UsageBlock
                            key={ item.type }
                            usage={{
                                type: item.type,
                                used: item.used,
                                limit
                            }}
                            fillColor={ fillColor }
                            limitText={ limitText }
                            notDollar={ notDollar }
                            showRemaining={ !limitText }
                        />
                    );
                }

                return null;
            })
        }

        {
            usage.unused.map((item) => {
                let limit = coverage[item.coverageColumn] || 0;
                let limitText = false;
                let notDollar = false;

                if (item.type === 'Erectile Dysfunction Drugs' && coverage.includeErectDysfuncDrugs === 0) {
                    return null;
                }

                if (item.type === 'Fertility Drugs' && coverage.includeFertilityDrugs === 0) {
                    return null;
                }

                if (item.type === 'Preventative Vaccines' && coverage.includePreventativeVaccines === 0) {
                    return null;
                }

                if (item.type === 'Smoking Cessations' && coverage.includeSmokingCessations === 0) {
                    return null;
                }

                if (item.type === 'Preventative Vaccines' && coverage.preventativeVaccinesIsRC) {
                    limitText = i18n.t(tokens.labels.coverage.unlimited);
                    limit = 50000;
                }

                if (item.type.includes('Generic') && (!coverage.hasOverallMax || coverage.secondMax.toUpperCase() === 'UNLIMITED')) {
                    limitText = i18n.t(tokens.labels.coverage.unlimited);
                    limit = 50000;
                }

                if (coverage[item.coverageColumn] || limitText) {
                    return (
                        <UsageBlock
                            key={ item.type }
                            usage={{
                                type: item.type,
                                used: item.used,
                                limit
                            }}
                            fillColor={ fillColor }
                            limitText={ limitText }
                            notDollar={ notDollar }
                        />
                    );
                }

                return null;
            })
        }
    </React.Fragment>
);

export default DrugsUsageBlock;